import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { schema } from './validation/schema';
import { inputsInState } from './InitialState';
import AppInput from '../../../../common/AppInput';

const useStyles = makeStyles(() => ({
  container: {
    '& > div > div': {
      width: '100%',
    },
    '& > div:not(:last-child)': {
      marginBottom: '-20px',
    },
  },
}));

const Form = ({ ...props }) => {
  const { onClick, state, dispatch, onFocus } = props;
  const classes = useStyles();

  const handleInputChange = (event) => {
    dispatch({
      field: event.target.name,
      value: {
        value: event.target.value,
        error: state[event.target.name].error,
        message: state[event.target.name].message,
        helper: state[event.target.name].helper,
        inputAdornment: state[event.target.name].inputAdornment,
        label: state[event.target.name].label,
        success: state[event.target.name].success,
      },
    });
  };

  const handleClick = (event) => {
    onClick(event.target.value);
  };

  const handleValidation = (event) => {
    if ('error' in schema.validate({ [event.target.name]: event.target.value }))
      dispatch({
        field: event.target.name,
        value: {
          value: event.target.value,
          error: true,
          message: schema.validate({ [event.target.name]: event.target.value })
            .error.message,
          helper: state[event.target.name].helper,
          inputAdornment: state[event.target.name].inputAdornment,
          label: state[event.target.name].label,
          success: false,
        },
      });
    else
      dispatch({
        field: event.target.name,
        value: {
          value: event.target.value,
          error: false,
          message: state[event.target.name].message,
          helper: state[event.target.name].helper,
          inputAdornment: state[event.target.name].inputAdornment,
          label: state[event.target.name].label,
          success: true,
        },
      });
  };

  useEffect(() => {
    onFocus(state);
  }, [state]);
  return (
    <Grid container spacing={2} className={classes.container}>
      {inputsInState.map((input) => (
        <Grid item md={6} xs={12} key={input}>
          <AppInput
            disabled={input === 'logonId'}
            name={input}
            error={state[input].error}
            value={state[input].value}
            label={state[input].label}
            helperText={state[input].helper}
            inputAdornment={state[input].inputAdornment}
            errorMessage={state[input].message}
            required
            success={state[input].success}
            onChange={handleInputChange}
            onClick={handleClick}
            onBlur={handleValidation}
          />
        </Grid>
      ))}
    </Grid>
  );
};

Form.propTypes = {
  onClick: PropTypes.func,
  state: PropTypes.array,
  dispatch: PropTypes.func,
  onFocus: PropTypes.func,
};

export default Form;
